import { Fragment, useEffect } from 'react'

import { getCookie, removeCookies } from 'cookies-next'
import TagManager from 'react-gtm-module'

import { useCurrentUserId } from 'lib/use-current-user-id'
import toString from 'lodash/toString'
import { useRouter } from 'next/router'

interface Props {
  children: React.ReactNode | React.ReactNode[]
}

const isDevelopment = 'development' === process.env.NEXT_PUBLIC_ENV

const Google = ({ children }: Props) => {
  const userId = useCurrentUserId()
  const router = useRouter()

  useEffect(() => {
    if (!isDevelopment) {
      TagManager.initialize({
        gtmId: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
      })
    }
  }, [userId, router.events]) // run only once!

  // Google Analytics 4
  useEffect(() => {
    const handleRouteChange = (url) => {
      if ('gtag' in window) {
        // @ts-ignore
        window.gtag('config', process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_4, {
          page_path: url,
        })
      }
    }
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  if (toString(getCookie('gtag_need_to_track_registration'))) {
    TagManager.dataLayer({
      dataLayer: {
        event: 'tay_user_registration',
      },
    })
    removeCookies('gtag_need_to_track_registration')
  }

  return <Fragment>{children}</Fragment>
}

export default Google
